import { useQuery } from 'react-query';
import { apiClient } from '../api/client';

export interface RecentActivity {
  id: string;
  action: string;
  time: string;
  type: string;
  details?: Record<string, any>;
}

export interface RecentActivitiesResponse {
  activities: RecentActivity[];
  total: number;
}

export const useRecentActivities = (limit: number = 10) => {
  return useQuery<RecentActivitiesResponse>({
    queryKey: ['recent-activities', limit],
    queryFn: async () => {
      const response = await apiClient.get(
        `/api/v1/scraper/status/recent-activities?limit=${limit}`
      );
      return response.data;
    },
    refetchInterval: 120000,
    staleTime: 60000,
    cacheTime: 300000,
  });
};
